exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bootstrap-dark .multiselect *{background-color:#343a40}", ""]);

// exports
